const loadScript = scriptUrl => {
  const script = document.createElement('script');
  script.src = scriptUrl;
  document.body.appendChild(script);

  return new Promise((res, rej) => {
    script.onload = () => {
      res(true);
    };
    script.onerror = () => {
      rej();
    };
  });
};

export default loadScript;
